import { useStepResponse, useChatStoreExtract } from '../../Chat/hooks/ChatStore.hooks';
import { ChatLayout, useChatLayoutStore } from '../hooks/useChatLayoutStore';
import { usePinStore } from '../hooks/usePinStore';
import { StepCard } from './StepCard';

type PinButtonProps = {
  responseIndex: number;
};

export const PinButton = ({ responseIndex }: PinButtonProps) => {
  const response = useStepResponse(responseIndex, true);
  const isDrawerOpen = useChatLayoutStore(state => state.isDrawerOpen);
  const setIsDrawerOpen = useChatLayoutStore(state => state.setIsDrawerOpen);
  const layout = useChatLayoutStore(state => state.layout);

  const multiChatIndex = useChatStoreExtract(state => state.currentMultiChatIndex);

  const isPinnedIndex = usePinStore(state => state.isPinnedIndex(responseIndex, multiChatIndex));
  const addPinnedIndex = usePinStore(state => state.addPinnedIndex);
  const removePinnedIndex = usePinStore(state => state.removePinnedIndex);

  const showPinIcon = layout === ChatLayout.Inline;

  if (!showPinIcon) return null;

  const tooltip = !response
    ? 'No response to pin'
    : isPinnedIndex
    ? 'Unpin this response'
    : 'Pin this response';
  return (
    <StepCard.Button
      icon={isPinnedIndex ? 'slash' : 'thumbtack'}
      iconProps={{
        mask: isPinnedIndex ? 'thumbtack' : undefined,
        transform: isPinnedIndex ? 'down-1' : undefined,
      }}
      onClick={() => {
        if (!isDrawerOpen) setIsDrawerOpen(true);
        isPinnedIndex
          ? removePinnedIndex(responseIndex, multiChatIndex)
          : addPinnedIndex(responseIndex, multiChatIndex);
      }}
      disabled={!response}
      tooltip={tooltip}
      enableDisabledTooltip
    />
  );
};
